// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__lccq3","content":"LoadingAlert_content__1z24u"};